import { ChurchCenterCustomFieldApiRecordWithRelationships } from "source/myChurchCenter/Profile/types"

export function groupCustomFieldsByHeaders(
  records: ChurchCenterCustomFieldApiRecordWithRelationships[],
): Array<{
  title: string
  description?: string
  items: ChurchCenterCustomFieldApiRecordWithRelationships[]
}> {
  if (!records || records.length === 0) {
    return []
  }

  const groups = records.reduce(
    (acc, record) => {
      const isHeader =
        record.attributes.name !== undefined &&
        record.relationships.field_definition.data.attributes.data_type ===
          "header"

      if (isHeader) {
        acc.push({
          title: record.attributes.name!,
          description: record.attributes.description,
          items: [],
        })
      } else {
        if (acc.length === 0) {
          acc.push({
            title: "Additional information",
            items: [],
          })
        }
        acc[acc.length - 1].items.push(record)
      }

      return acc
    },
    [] as Array<{
      title: string
      description?: string
      items: ChurchCenterCustomFieldApiRecordWithRelationships[]
    }>,
  )

  return groups.filter((group) => group.items.length > 0)
}
